<template>
  <div class="pwd-strength">
    <ul class="pwd-strength-bar">
      <li class="point" :class="password ? 'score0' : 'default'"></li>
      <li class="point" :class="strength > 0 ? 'score1' : 'default'"></li>
      <li class="point" :class="strength > 1 ? 'score2' : 'default'"></li>
      <li class="point" :class="strength > 2 ? 'score3' : 'default'"></li>
      <li class="point" :class="strength > 3 ? 'score4' : 'default'"></li>
    </ul>
    <small v-if="password" class="pwd-strength-label">
      {{ $t(`profile.edit.passwordStrength.${strength}`) }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'PasswordStrengthBar',
  props: {
    password: { type: String, default: '' }
  },
  computed: {
    /**
     * Password-strength-meter with the same functionality as services-platform one
     */
    strength() {
      let score;
      let points = 0;
      let variationCount = 0;
      const letters = {};

      if (!this.password) return 0;

      // Award every unique letter up to 5 repetitions
      for (let i = 0; i < this.password.length; i++) {
        letters[this.password[i]] = (letters[this.password[i]] || 0) + 1;
        points += 5.0 / letters[this.password[i]];
      }

      // Add bonus points for mixing it up
      const variations = {
        digits: /\d/.test(this.password),
        lower: /[a-z]/.test(this.password),
        upper: /[A-Z]/.test(this.password),
        nonWords: /\W/.test(this.password)
      };
      Object.keys(variations).forEach((check) => (variationCount += variations[check] ? 1 : 0));
      points += (variationCount - 1) * 10;

      score = Math.trunc(points);
      if (score > 90) {
        return 4;
      } else if (score > 70) {
        return 3;
      } else if (score >= 40) {
        return 2;
      } else if (score >= 20) {
        return 1;
      }
      return 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.pwd-strength {
  .default {
    background-color: #ddd;
  }
  .score0 {
    background-color: #f00;
  }
  .score1 {
    background-color: #f90;
  }
  .score2 {
    background-color: #ff0;
  }
  .score3 {
    background-color: #9f0;
  }
  .score4 {
    background-color: #0f0;
  }

  ul.pwd-strength-bar {
    display: inline;
    list-style: none;
    margin: 0;
    padding: 0;
    vertical-align: 2px;

    .point:last {
      margin: 0 !important;
    }

    .point {
      border-radius: 2px;
      display: inline-block;
      height: 5px;
      margin-right: 1%;
      width: 10%;
    }
  }

  .pwd-strength-label {
    margin-left: 15px;

    font-size: var(--small);
    font-weight: 200;
    color: var(--dusk);
  }
}
</style>
